import Immutable from 'immutable';

import {
  INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_START,
  INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_SUCCESS,
  INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_FAILURE,
  INSTITUTION_ADMIN_UI_REMOVE_COURSE_START,
  INSTITUTION_ADMIN_UI_REMOVE_COURSE_SUCCESS,
  INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE,
  INSTITUTION_COURSES_FETCH_START,
  INSTITUTION_COURSES_FETCH_FAILURE,
  INSTITUTION_COURSES_FETCH_SUCCESS,
  INSTITUTION_COURSES_AND_COHORTS_FETCH_SUCCESS,
  INSTITUTION_COURSES_AND_COHORTS_FETCH_FAILURE,
  INSTITUTION_INVITE_COURSE_SELECTED,
  FETCH_INSTITUTION_INVITE_COURSE_SUCCESS,
  FETCH_INSTITUTION_INVITE_COURSE_FAILURE,
  LINK_COURSES_TO_INSTITUTION_SUCCESS,
  LINK_COURSES_TO_INSTITUTION_FAILURE,
  TOGGLE_COHORT_CHECKBOX,
  TOGGLE_COURSE_CHECKBOX,
  FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE,
  FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS,
  FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_START,
  UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE,
  SET_INSTITUTION_LTI_CONSUMER_COHORT_CONTEXT_ID,
  FETCH_COURSE_CATEGORY_NAMES,
  INSTITUTION_ADMIN_UI_COURSES_RESET_ACTION,
  INSTITUTION_SEND_INVITATION_START,
  INSTITUTION_SEND_INVITATION_SUCCESS,
  INSTITUTION_SEND_INVITATION_FINISH,
  FETCH_INSTITUTION_LINKABLE_COURSES_SUCCESS,
} from './actions';
import {
  FETCH_INSTITUTION_STUDENT_DATA_SUCCESS,
  FETCH_INSTITUTION_STUDENT_DATA_FAILURE,
} from './StudentData/actions';
import { ROUTE_INSTITUTION_ADMIN } from '../../ReduxStorage/routeActions';

import { CREATE_COURSE_FAILURE } from '../Courses/actions';
import { INVITEE_STATUS } from './constants';

const initialState = Immutable.fromJS({});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function InstitutionAdminUI(state = initialState, action = {}) {
  const loadingStart = (keyPath) => {
    return state.setIn(
      keyPath,
      Immutable.fromJS({
        loading: true,
        error: null,
        data: null,
      })
    );
  };

  const loadingSuccess = (keyPath, data) => {
    return state.setIn(
      keyPath,
      Immutable.fromJS({
        loading: false,
        error: null,
        data,
      })
    );
  };

  const loadingFailure = (keyPath, error) => {
    return state.setIn(
      keyPath,
      Immutable.fromJS({
        loading: false,
        error,
        data: null,
      })
    );
  };
  const actionStart = (keyPath) => {
    return state.mergeIn(
      keyPath,
      Immutable.fromJS({
        loading: true,
        error: null,
      })
    );
  };
  const actionFailure = (keyPath, error) => {
    return state.mergeIn(
      keyPath,
      Immutable.fromJS({
        loading: false,
        error,
      })
    );
  };
  const actionReset = (keyPath) => {
    return state.mergeIn(
      keyPath,
      Immutable.fromJS({
        loading: false,
        error: null,
      })
    );
  };

  switch (action.type) {
    case INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_START: {
      return state.setIn(
        [action.institutionPath, 'activeUsers'],
        Immutable.fromJS({
          loading: true,
          error: null,
          data: null,
        })
      );
    }
    case INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_SUCCESS: {
      return state.setIn(
        [action.institutionPath, 'activeUsers'],
        Immutable.fromJS({
          loading: false,
          error: null,
          data: action.data,
        })
      );
    }
    case INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_FAILURE: {
      return state.setIn(
        [action.institutionPath, 'activeUsers'],
        Immutable.fromJS({
          loading: false,
          error: action.error,
          data: null,
        })
      );
    }
    case INSTITUTION_ADMIN_UI_REMOVE_COURSE_SUCCESS:
    case INSTITUTION_ADMIN_UI_COURSES_RESET_ACTION: {
      return actionReset([action.institutionPath, 'courses']);
    }
    case INSTITUTION_ADMIN_UI_REMOVE_COURSE_START: {
      return actionStart([action.institutionPath, 'courses']);
    }
    case ROUTE_INSTITUTION_ADMIN: {
      const {
        query: { action: queryAction, institution: institutionPath },
      } = action;

      switch (queryAction) {
        case 'invite': {
          let newState = loadingStart([institutionPath, 'courses']);

          newState = newState.setIn(
            [institutionPath, 'invite', 'activeCohorts'],
            Immutable.Map()
          );

          newState = newState.setIn(
            [institutionPath, 'invite', 'activeCourses'],
            Immutable.List()
          );

          return newState;
        }
        case 'studentData': {
          const requestId =
            state.getIn([institutionPath, 'studentData', 'requestId'], 0) + 1;

          return state.mergeIn([institutionPath, 'studentData'], {
            loading: true,
            requestId,
          });
        }
        default: {
          return state;
        }
      }
    }
    case INSTITUTION_COURSES_FETCH_START: {
      return loadingStart([action.institutionPath, 'courses']);
    }
    case INSTITUTION_COURSES_AND_COHORTS_FETCH_SUCCESS: {
      return loadingSuccess([action.institutionPath, 'courses'], action.data);
    }
    case INSTITUTION_INVITE_COURSE_SELECTED: {
      const { institutionPath } = action;
      return state.setIn([institutionPath, 'invite', 'loading'], true);
    }
    case FETCH_INSTITUTION_INVITE_COURSE_SUCCESS: {
      const { institutionPath, data } = action;
      const courses = Immutable.fromJS(data.courses);

      let newState = state.updateIn(
        [institutionPath, 'invite', 'activeCourses'],
        Immutable.List(),
        (courseList) => courseList.concat(courses)
      );

      courses.forEach((course) => {
        course.get('classes').forEach((cohort) => {
          newState = newState.setIn(
            [
              institutionPath,
              'invite',
              'activeCohorts',
              cohort.get('path'),
              'checked',
            ],
            true
          );
        });
      });

      newState = newState.setIn([institutionPath, 'invite', 'loading'], false);
      return newState;
    }
    case FETCH_INSTITUTION_INVITE_COURSE_FAILURE: {
      const { institutionPath, error } = action;
      return state.mergeIn([institutionPath, 'invite'], {
        loading: false,
        error,
      });
    }
    case INSTITUTION_COURSES_FETCH_SUCCESS: {
      return loadingSuccess([action.institutionPath, 'courses'], action.data);
    }
    case INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE:
    case CREATE_COURSE_FAILURE:
    case LINK_COURSES_TO_INSTITUTION_FAILURE: {
      return actionFailure([action.institutionPath, 'courses'], action.error);
    }
    case INSTITUTION_COURSES_AND_COHORTS_FETCH_FAILURE: {
      return loadingFailure([action.institutionPath, 'courses'], action.error);
    }
    case INSTITUTION_COURSES_FETCH_FAILURE: {
      return loadingFailure([action.institutionPath, 'courses'], action.error);
    }
    case TOGGLE_COHORT_CHECKBOX: {
      const { institutionPath, cohort } = action;
      const checked = !state.getIn(
        [
          institutionPath,
          'invite',
          'activeCohorts',
          cohort.get('path'),
          'checked',
        ],
        false
      );
      return state.setIn(
        [
          institutionPath,
          'invite',
          'activeCohorts',
          cohort.get('path'),
          'checked',
        ],
        checked
      );
    }
    case TOGGLE_COURSE_CHECKBOX: {
      const { course } = action;
      const coursePath = course.get('path');
      return state.update('coursesToLink', (coursesToLink) => {
        if (coursesToLink.has(coursePath)) {
          return coursesToLink.delete(coursePath);
        }
        return coursesToLink.add(coursePath);
      });
    }
    case FETCH_INSTITUTION_LINKABLE_COURSES_SUCCESS: {
      const { coursePaths } = action;

      return state.merge({
        coursePaths: Immutable.Set(coursePaths),
        coursesToLink: Immutable.Set(),
      });
    }
    case LINK_COURSES_TO_INSTITUTION_SUCCESS: {
      const { coursePaths } = action;

      let newState = state;
      newState = newState.update('coursePaths', (paths) =>
        paths.union(Immutable.Set(coursePaths))
      );
      newState = newState.update('coursesToLink', (coursesToLink) =>
        coursesToLink.clear()
      );
      return newState;
    }
    case FETCH_COURSE_CATEGORY_NAMES: {
      return state.setIn(
        [action.institutionPath, 'categories'],
        action.categories
      );
    }
    case FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_START: {
      return state.setIn(
        [
          action.institutionPath,
          'ltiIntegration',
          action.coursePath,
          'contextMappings',
        ],
        Immutable.fromJS({
          loading: true,
          error: null,
          data: null,
        })
      );
    }
    case FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS: {
      return state.setIn(
        [
          action.institutionPath,
          'ltiIntegration',
          action.coursePath,
          'contextMappings',
        ],
        Immutable.fromJS({
          loading: false,
          error: null,
          data: action.contextIdsByCohort,
        })
      );
    }
    case FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE:
    case UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE: {
      return state.setIn(
        [
          action.institutionPath,
          'ltiIntegration',
          action.coursePath,
          'contextMappings',
        ],
        Immutable.fromJS({
          loading: false,
          error: action.error,
          data: null,
        })
      );
    }
    case SET_INSTITUTION_LTI_CONSUMER_COHORT_CONTEXT_ID: {
      return state.setIn(
        [
          action.institutionPath,
          'ltiIntegration',
          action.coursePath,
          'contextMappings',
          'data',
          action.cohortPath,
          'context_id',
        ],
        action.newContextId
      );
    }
    case INSTITUTION_SEND_INVITATION_START: {
      let newState = state.setIn(
        [action.institutionPath, 'invite', 'invitees'],
        Immutable.Map()
      );
      newState = newState.setIn(
        [action.institutionPath, 'invite', 'processing'],
        true
      );
      action.invitees.forEach((invitee) => {
        newState = newState.setIn(
          [action.institutionPath, 'invite', 'invitees', invitee],
          Immutable.fromJS({
            status: INVITEE_STATUS.UNTOUCHED,
          })
        );
      });

      return newState;
    }
    case INSTITUTION_SEND_INVITATION_SUCCESS: {
      let newState = state;
      const {
        institutionPath,
        autoEnrolledStudents,
        alreadyEnrolledStudents,
        pendingEnrolledEmails,
        unprocessedEmails,
      } = action;

      autoEnrolledStudents.forEach((user) => {
        newState = newState.setIn(
          [institutionPath, 'invite', 'invitees', user.email],
          Immutable.fromJS({
            data: user.user,
            status: INVITEE_STATUS.AUTO_ENROLLED,
          })
        );
      });

      alreadyEnrolledStudents.forEach((user) => {
        newState = newState.setIn(
          [institutionPath, 'invite', 'invitees', user.email],
          Immutable.fromJS({
            data: user.user,
            status: INVITEE_STATUS.ALREADY_ENROLLED,
          })
        );
      });

      pendingEnrolledEmails.forEach(
        (email) =>
          (newState = newState.setIn(
            [institutionPath, 'invite', 'invitees', email],
            Immutable.fromJS({
              status: INVITEE_STATUS.PENDING_ENROLLED,
            })
          ))
      );

      unprocessedEmails.forEach((email) => {
        newState = newState.setIn(
          [institutionPath, 'invite', 'invitees', email],
          Immutable.fromJS({
            status: INVITEE_STATUS.UNPROCESSED,
          })
        );
      });

      return newState;
    }
    case INSTITUTION_SEND_INVITATION_FINISH: {
      return state.setIn(
        [action.institutionPath, 'invite', 'processing'],
        false
      );
    }
    case FETCH_INSTITUTION_STUDENT_DATA_SUCCESS: {
      const {
        institutionPath,
        requestId,
        request,
        total,
        students,
        courses,
        course,
        nextPage,
        previousPage,
      } = action;

      const currentRequestId = state.getIn([
        institutionPath,
        'studentData',
        'requestId',
      ]);

      if (requestId !== currentRequestId) {
        return state;
      }

      return state.mergeIn([institutionPath, 'studentData'], {
        loading: false,
        students,
        total,
        nextPage,
        previousPage,
        courses: course
          ? courses.setIn([course.get('path'), 'loaded'], true)
          : courses,
        lastRequest: request,
      });
    }
    case FETCH_INSTITUTION_STUDENT_DATA_FAILURE: {
      const { institutionPath, requestId, request, courses, course } = action;

      const currentRequestId = state.getIn([
        institutionPath,
        'studentData',
        'requestId',
      ]);

      if (requestId !== currentRequestId) {
        return state;
      }

      let newState = state.mergeIn([institutionPath, 'studentData'], {
        loading: false,
        students: Immutable.List(),
        total: 0,
        lastRequest: request,
        nextPage: null,
        previousPage: null,
      });

      newState = newState.updateIn(
        [institutionPath, 'studentData', 'courses'],
        courses || null,
        (currentCourses) => {
          if (
            currentCourses &&
            course &&
            currentCourses.has(course.get('path'))
          ) {
            return currentCourses.setIn([course.get('path'), 'loaded'], true);
          }
          return currentCourses;
        }
      );

      return newState;
    }

    default: {
      return state;
    }
  }
}
